module.exports = __webpack_public_path__ + "static/thumbnail-8cfa631d24838af993aa4c9b419a19c8.png";